<template>
  <div>
    <div v-if="memos.length > 0">
      <component
        :is="getComponent()"
        v-for="(memo, index) in memos"
        :key="memo.id"
        :prop-memo="memo"
        @update="updateMemo"
        @delete="deleteMemo"
      />
    </div>
    <div class="fz125 fw-b ta-c mt30" v-else>まだメモはありません。</div>
  </div>
</template>

<script>
import { popupSuccess, popupError, popupInfo } from '@/packs/person/popup';
import Selfpr from './PersonMemoList/Selfpr.vue';
import Reason from './PersonMemoList/Reason.vue';
import Point from './PersonMemoList/Point.vue';
import Gakuchika from './PersonMemoList/Gakuchika.vue';
import Seminar from './PersonMemoList/Seminar.vue';
import CareerHistory from './PersonMemoList/CareerHistory.vue';
import EsHistory from './PersonMemoList/EsHistory.vue';
import CheckList from './PersonMemoList/CheckList.vue';
import QuestionBasic from './PersonMemoList/QuestionBasic.vue';
import QuestionForYou from './PersonMemoList/QuestionForYou.vue';
import Free from './PersonMemoList/Free.vue';
import RecommendationCompany from './PersonMemoList/RecommendationCompany.vue';

const MEMO_COMPONENT_MAP = {
  selfpr: Selfpr,
  reason: Reason,
  point: Point,
  gakuchika: Gakuchika,
  seminar: Seminar,
  career_history: CareerHistory,
  es_history: EsHistory,
  checklist: CheckList,
  question_basic: QuestionBasic,
  question_for_you: QuestionForYou,
  free: Free,
  recommendation_company: RecommendationCompany,
}

const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

export default {
  props: {
    propMemoType: String,
    propMemos: Array,
    propMemoPath: String,
  },
  data() {
    return {
      memos: [],
      deleteMemoId: null,
      deleteOnFinally: null,
      addQuestionForm: null,
    }
  },
  watch: {
    memos(newMemos) {
      if (this.propMemoType === 'question_basic' || this.propMemoType === 'question_for_you') {
        const questionIds = new Set(newMemos.map((memo) => memo.question_id));
        $(this.addQuestionForm).find('input[name^="[question_id]"]').each(function() {
          $(this).prop('checked', questionIds.has($(this).attr('name').replace('[question_id]', '')));
        });
      }
    }
  },
  created() {
    this.memos = this.propMemos;
  },
  mounted() {
    this.addQuestionForm = $('#addQuestion')[0];
    if (this.addQuestionForm) {
      this.addQuestionForm.addEventListener('submit', this.handleAddQuestion);
    }

    const button = $('#deleteMemoConfirmationButton')[0];
    if (button) {
      button.addEventListener('click', this.confirmDelete);
    }

    if (this.propMemoType === 'free') {
      $('#addFreeMemo').on('click', (e) => {
        this.addMemo();
      });
    }
  },
  beforeDestroy() {
    if (this.addQuestionForm) {
      this.addQuestionForm.removeEventListener('submit', this.handleAddQuestion);
    }

    const button = $('#deleteMemoConfirmationButton')[0];
    if (button) {
      button.removeEventListener('click', this.confirmDelete);
    }
  },
  methods: {
    getComponent() {
      return MEMO_COMPONENT_MAP[this.propMemoType] || Selfpr;
    },

    // メモを追加
    async addMemo() {
      popupInfo('メモを追加しています…');
      const res = await fetch(this.propMemoPath, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/json',
        },
      });
      if (res.ok) {
        const data = await res.json();
        this.memos.unshift(data.memo);
        popupSuccess('メモを追加しました');
      } else {
        popupError('メモの追加に失敗しました');
      }
    },

    // メモを更新
    async updateMemo({ memoId, text, onFinally }) {
      const res = await fetch(this.propMemoPath, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ memo_id: memoId, text: text }),
      });
      onFinally();
      if (res.ok) {
        const data = await res.json();
        const index = this.memos.findIndex((memo) => memo.id === memoId);
        this.$set(this.memos[index], 'text', data.memo.text);
        popupSuccess('保存しました');
      } else {
        popupError('保存に失敗しました');
      }
    },

    //メモを削除
    deleteMemo({ memoId, onFinally }) {
      this.deleteMemoId = memoId;
      this.deleteOnFinally = onFinally;
    },
    async confirmDelete() {
      popupInfo('削除しています…');
      const res = await fetch(this.propMemoPath, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ memo_id: this.deleteMemoId }),
      });

      if (this.deleteOnFinally) this.deleteOnFinally();

      if (res.ok) {
        const data = await res.json();
        this.memos = this.memos.filter((memo) => memo.id !== data.memo.id);
        popupSuccess('削除しました');
      } else {
        popupError('削除に失敗しました');
      }
    },


    async handleAddQuestion(e) {
      e.preventDefault();

      const form = this.addQuestionForm;
      const formData = new FormData(form);
      const res = await fetch(form.action, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'X-CSRF-Token': csrfToken,
        },
        body: formData,
      });

      if (res.ok) {
        const data = await res.json();
        this.memos = data.memos;
        popupSuccess('質問を追加しました');
      }
    },
  },
}
</script>
